var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.21753C16.3617 5.45457 16.875 6.15767 16.875 6.96518V10.5365C16.875 11.4837 16.1688 12.2869 15.2248 12.3639C14.9423 12.387 14.6591 12.4071 14.375 12.4244V15L11.875 12.5C10.7469 12.5 9.62967 12.454 8.52519 12.3638C8.2766 12.3436 8.0445 12.2729 7.83745 12.1625M15.625 5.21753C15.4988 5.17693 15.3661 5.15 15.2283 5.13856C14.1227 5.0468 13.0043 5 11.875 5C10.7457 5 9.62733 5.0468 8.52174 5.13856C7.57916 5.21679 6.875 6.01936 6.875 6.96518V10.5364C6.875 11.2342 7.25822 11.8538 7.83745 12.1625M15.625 5.21753V3.65609C15.625 2.30491 14.6652 1.13387 13.3253 0.959925C11.6232 0.738964 9.88752 0.625 8.12524 0.625C6.36278 0.625 4.62694 0.738987 2.9247 0.959991C1.58477 1.13395 0.625 2.30498 0.625 3.65615V8.84387C0.625 10.195 1.58478 11.3661 2.9247 11.54C3.40551 11.6024 3.88899 11.6563 4.375 11.7015V15.625L7.83745 12.1625",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessageIcon);
export default __webpack_public_path__ + "static/media/chat-message-icon.5284f287f1d7c479d30eb0971ee3845e.svg";
export { ForwardRef as ReactComponent };